"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeRanges = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
exports.TimeRanges = {
    EARLYMORNING: {
        title: 'Early Morning',
        from: () => (0, moment_timezone_1.default)().tz('UTC').startOf('day'),
        to: from => from.clone().add(6, 'hours').subtract(1, 'millisecond'),
    },
    MORNING: {
        title: 'Morning',
        from: () => (0, moment_timezone_1.default)().tz('UTC').startOf('day').add(6, 'hours'),
        to: from => from.clone().add(6, 'hours').subtract(1, 'millisecond'),
    },
    AFTERNOON: {
        title: 'Afternoon',
        from: () => (0, moment_timezone_1.default)().tz('UTC').startOf('day').add(12, 'hours'),
        to: from => from.clone().add(6, 'hours').subtract(1, 'millisecond'),
    },
    EVENING: {
        title: 'Evening',
        from: () => (0, moment_timezone_1.default)().tz('UTC').startOf('day').add(18, 'hours'),
        to: from => from.clone().add(6, 'hours').subtract(1, 'millisecond'),
    },
};
exports.default = exports.TimeRanges;
